import React from 'react';
import PropTypes from 'prop-types';
/*
 * all of the exported grid component extent the spacing mixin from foundation
 *   via ${props => props.theme.ns().spacing.getSpacingMixin()};
 *
 *   ex:
 *     <Row marginBottom={'xs'} />
 *
 * https://foundation.in.zillow.net/foundation-api.html#section-spacing
 */

import styled from 'styled-components';

import { Row as GridSystemRow, Hidden } from 'react-grid-system';
import rowMixin from '../../themes/components/Row';
import T_SHIRT_SIZES from '../../constants/T_SHIRT_SIZES';

const StyledRow = styled(({ noMargin, paddingX, paddingY, mediaQuery, ...rest }) => <GridSystemRow {...rest} />)`
  ${rowMixin}
`;

const Row = ({ hidden, ...restProps }) => {
  const hiddenSizes = {};
  if (hidden) {
    hidden.forEach((size) => {
      hiddenSizes[size] = true;
    });
  }

  return (
    <Hidden {...hiddenSizes}>
      <StyledRow data-test="row" {...restProps} />
    </Hidden>
  );
};

Row.propTypes = {
  /** Specified breakpoints will be hidden */
  hidden: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(T_SHIRT_SIZES))),
  /**
   * remove default margin on component
   */
  noMargin: PropTypes.bool,
  paddingX: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  paddingY: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Row.defaultProps = {
  hidden: null,
  noMargin: false,
  paddingY: null,
  paddingX: null,
};

/** @component */
export default Row;
